/* @velyn-custom BEGIN — review-design.js
   Rounds the REVIEWS.io average rating to one decimal (4.83 -> 4.8, 4.86 -> 4.9).

   Why JS: the vendor prints the raw average as a text node. CSS cannot do
   arithmetic, and REVIEWS.io exposes no decimal-places option on the Polaris
   widget. If a future Widget Builder setting covers this, delete this file and
   its stylesheet_tag/script_tag pair in sections/vely-product-reviews.liquid.

   Safe against vendor re-renders: the observer is debounced and the write is
   guarded by an equality check, so rewriting the value cannot re-trigger
   itself into a loop.
*/
(function () {
  'use strict';

  var HOST = '.section-vely-product-reviews .vely-product-reviews__widget';
  var AVERAGE = '.header__group--left .R-TextHeading--md';
  var DECIMALS = 1;

  function round(scope) {
    var nodes = (scope || document).querySelectorAll(AVERAGE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var raw = (el.textContent || '').trim();
      if (!raw) continue;
      var value = parseFloat(raw.replace(',', '.'));
      if (isNaN(value)) continue;
      var next = value.toFixed(DECIMALS);
      if (raw !== next) el.textContent = next;
    }
  }

  function watch(host) {
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        round(host);
      }, 60);
    });
    observer.observe(host, { childList: true, subtree: true });
    round(host);
  }

  function init() {
    var hosts = document.querySelectorAll(HOST);
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', init);
})();
/* @velyn-custom END — review-design.js */
